import classNames from 'classnames';

interface Props {
  readonly bullets: (string | undefined)[];
  readonly textSize?: string;
  readonly textColour?: string;
  readonly className?: string;
  readonly bulletClasses?: string;
  readonly noWrap?: boolean;
  readonly dataTestId?: string;
}

const Bullets = ({
  bullets,
  textSize = 'body-three',
  textColour = 'text-black-100 dark:text-white',
  className,
  bulletClasses,
  noWrap = true,
  dataTestId,
}: Props) => {
  const filteredBullets = bullets.filter(Boolean);
  if (!filteredBullets.length) return null;

  return (
    <div
      className={classNames('flex flex-wrap items-center', className)}
      data-testid={dataTestId}
    >
      {filteredBullets.map((bullet, index) => (
        <span
          key={bullet}
          className={classNames(
            { 'whitespace-nowrap': noWrap },
            'pr-2',
            textColour,
            textSize,
            bulletClasses
          )}
        >
          {index !== 0 && (
            <span className="mr-2 text-black-100 dark:text-yellow">•</span>
          )}
          {bullet}
        </span>
      ))}
    </div>
  );
};

export default Bullets;
